import * as React from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getProyectosApiBaseUrl } from "../../utils/proyectosApiBaseUrl";
import type { BurdenMedidorHomologado } from "../../utils/burdenCalculo";
import BurdenMedidoresAdmin from "./BurdenMedidoresAdmin";

const getToken = () => {
  try {
    return atob(localStorage.getItem("authToken") || "") || "";
  } catch {
    return "";
  }
};

type Props = {
  open: boolean;
  onClose: () => void;
  /** Se invoca tras crear, editar o eliminar para refrescar listas del cálculo. */
  onActualizado?: () => void;
};

export default function BurdenMedidoresAdminModal({ open, onClose, onActualizado }: Props) {
  const [medidores, setMedidores] = React.useState<BurdenMedidorHomologado[]>([]);
  const [loading, setLoading] = React.useState(false);

  const cargar = React.useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch(`${getProyectosApiBaseUrl()}/burden/medidores?todos=1`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "No se pudo cargar medidores.");
      setMedidores(Array.isArray(data.medidores) ? data.medidores : []);
    } catch {
      setMedidores([]);
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    if (open) void cargar();
  }, [open, cargar]);

  const handleChange = () => {
    void cargar();
    onActualizado?.();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth scroll="paper">
      <DialogTitle sx={{ pr: 6 }}>
        Medidores homologados EMCALI
        <IconButton
          aria-label="Cerrar"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <CircularProgress size={28} sx={{ display: "block", mx: "auto", my: 3 }} />
        ) : (
          <BurdenMedidoresAdmin medidores={medidores} onChange={handleChange} embedded />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
}
